import { createContent } from '@altify/utils';

export const content = createContent({
  en: {
    cryptoIsVolatile: 'Crypto Prices Are Volatile',
    riskDisclosureWarning: {
      intro: 'Make sure to have reviewed our',
      orderPolicy: 'Order Execution Policy',
      generalRisk: 'General Risk Disclosures',
      cryptoRisk: 'Crypto Risk Disclosures.',
    },
    capitalAtRisk: 'When investing, your capital is at risk.',
  },
  de: {
    cryptoIsVolatile: 'Kryptopreise Sind Volatil',
    riskDisclosureWarning: {
      intro: 'Vergewissere dich, dass du die folgenden Hinweise gelesen hast:',
      orderPolicy: 'Order Execution Policy',
      generalRisk: 'General Risk Disclosures',
      cryptoRisk: 'Crypto Risk Disclosures.',
    },
    capitalAtRisk: 'Beim Investieren ist dein Kapital gefährdet.',
  },
});
